const countryCodeOf = (country, countries) => {
  const infos = countries.find(countryInfo => countryInfo.label === country);
  return infos && infos.code2 ? infos.code2 : '??';
};

export default countryCodeOf;
